<template>
  <div>
    <profile-app-bar
      :title="$currentUser.username"
    />

    <v-card
      dark
      tile
      color="accent"
    >
      <div
        class="d-flex text-center py-6"
      >
        <div
          :style="{
          flex: 1,
        }"
        >
          <span
            class="font-weight-bold display-1"
          >
            {{ $currentUser.cachedPostsCount }}
          </span>

          <span
            class="overline"
          >
            kuvaa
          </span>
        </div>

        <div
          :style="{
          flex: 1,
        }"
        >
          <span
            class="font-weight-bold display-1"
          >
            {{ $currentUser.cachedCommentsCount }}
          </span>

          <span
            class="overline"
          >
            Kommenttia
          </span>
        </div>
      </div>
    </v-card>

    <v-container
      class="pa-4"
    >
      <div
        class="d-flex justify-center mt-4 mb-8"
      >
        <v-btn
          elevation="6"
          large
          dark
          color="secondary"
          class="px-6"
          @click="openBuyMeCoffeeDialog"
        >
          Piilota mainokset
        </v-btn>
      </div>

      <v-card>
        <v-list
          two-line
        >
          <template
            v-for="(item, i) in listItems"
          >
          <v-list-item
            :key="i"
            @click="item.action"
          >
            <v-list-item-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>

              <v-list-item-subtitle>
                {{ item.subtitle }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon>
                keyboard_arrow_right
              </v-icon>
            </v-list-item-action>
          </v-list-item>

            <v-divider
              v-if="i < listItems.length - 1"
              :key="`i-${i}-divider`"
            />
          </template>
        </v-list>
      </v-card>

      <v-card
        class="mt-4"
        outlined
      >
        <v-btn
          text
          block
          large
          color="secondary"
          @click="openFeedbackDialog"
        >
          Lähetä palautetta
          <v-icon right small>feedback</v-icon>
        </v-btn>
      </v-card>

      <push-notification-card
        class="mt-4"
      />

      <v-subheader
        class="mt-4"
      >
        Danger Zone
      </v-subheader>

      <v-card
        outlined
      >
        <v-list-item
          three-line
        >
          <v-list-item-content>
            <v-list-item-title
              class="font-weight-bold"
            >
              Poista profiili
            </v-list-item-title>

            <v-list-item-subtitle>
              Profiili ja kaikki sen tiedot poistetaan välittömästi. Toimintoa ei voida perua.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions
          class="px-4 pb-4 pt-0"
        >
          <v-btn
            :disabled="
              (confirmProfileDestroy && !profileDestroyConfirmed) || $wait.is('destroying profile')
            "
            :loading="$wait.is('destroying profile')"
            color="error"
            outlined
            small
            @click="deleteProfile"
          >
            {{ confirmProfileDestroy ? 'Vahvista & poista profiili' : 'Poista profiili' }}
          </v-btn>

          <v-switch
            v-if="confirmProfileDestroy"
            v-model="profileDestroyConfirmed"
            color="error"
            class="mt-0 pt-0 ml-4"
            hide-details
          >
            <template v-slot:label>
              <span
                class="caption"
              >
                Vahvista
              </span>
            </template>
          </v-switch>
        </v-card-actions>
      </v-card>
    </v-container>

    <p
      class="mb-0 text-center overline"
    >
      Vilke © {{ $dayjs().format('YYYY') }}
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapWaitingActions } from 'vue-wait';
import ProfileAppBar from '../components/ProfileAppBar.vue';
import PushNotificationCard from '../components/PushNotificationCard.vue';

export default {
  components: {
    ProfileAppBar,
    PushNotificationCard,
  },

  computed: {
    listItems() {
      return [
        {
          icon: 'photo_library',
          title: 'Omat kuvat',
          subtitle: `${this.$currentUser.cachedPostsCount} kpl`,
          action: () => this.$router.push('/profiili/omat-kuvat/uudet'), // eslint-disable-line
        },

        {
          icon: 'comment',
          title: 'Omat kommentit',
          subtitle: `${this.$currentUser.cachedCommentsCount} kpl`,
          action: () => this.$router.push('/profiili/omat-kommentit/uudet'), // eslint-disable-line
        },
      ];
    },
  },

  data: () => ({
    confirmProfileDestroy: false,
    profileDestroyConfirmed: false,
  }),

  methods: {
    ...mapActions({
      openDialog: 'dialog/openDialog',
      logout: 'currentUser/logout',
    }),

    ...mapWaitingActions('currentUser', {
      destroyProfile: 'destroying profile',
    }),

    openFeedbackDialog() {
      this.openDialog({
        dialogComponent: 'submit-feedback',
        config: {
          fullscreen: true,
        },
      });
    },

    openBuyMeCoffeeDialog() {
      this.$gtm.hideAds();
      this.openDialog({
        dialogComponent: 'buy-me-coffee',
        config: {
          fullscreen: true,
        },
      });
    },

    async deleteProfile() {
      if (this.confirmProfileDestroy) {
        await this.destroyProfile({ userId: this.$currentUser.id });
        await this.logout();
        await this.$router.replace({ name: 'login' });
        this.$notifySuccess({ msg: 'Profiili poistetaan 1 minuutin kuluessa' });
      } else {
        this.confirmProfileDestroy = true;
      }
    },
  },
};
</script>
